import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import PaySalariesComp from './PaySalariesComp';

function PaySalaries() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <PaySalariesComp />
      </div>
    </div>
  );
}

export default PaySalaries;
